import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { TrashSolid } from '@alefeducation/ui-elements-library-icons';
import { IconButton } from '@alefeducation/ui-elements-library-core';
import { RNPAction, useRNPActionsContext } from './context';
import { ConfirmModal } from '../../../../utils/ConfirmModal';

const StyledContainer = styled.div``;

type Props = {
  id: string;
  name: string;
};

const RNPActions = ({ id, name }: Props) => {
  const { actionsToRender, onDelete } = useRNPActionsContext();
  const selectedAction = useRef('');
  const [isOpen, setIsOpen] = useState(false);

  const handleOnDelete = () => {
    onDelete({
      roleId: id,
      roleName: name,
    });
  };

  const getDialogData = () => {
    const data = {
      [RNPAction.delete]: {
        message: `Are you sure you want to delete “${name}” ? `,
        action: handleOnDelete,
      },
    };

    return data[selectedAction.current as RNPAction] || null;
  };

  const getActions = (action: RNPAction) => {
    const actions = {
      [RNPAction.delete]: (
        <span
          key="icon-delete-button"
          data-testid="rnp-action-icon-delete"
          onClick={(e) => {
            e.stopPropagation();
            selectedAction.current = RNPAction.delete;
            setIsOpen(true);
          }}
        >
          <IconButton onClick={() => {}} size="small" tooltipContent="Delete">
            <TrashSolid />
          </IconButton>
        </span>
      ),
    };

    return actions[action];
  };

  const dialogData = getDialogData();
  return (
    <StyledContainer>
      {actionsToRender.map((action) => getActions(action))}
      {dialogData && (
        <ConfirmModal
          open={isOpen}
          heading=""
          message={dialogData.message}
          modalVisibility={() => {
            selectedAction.current = '';
            setIsOpen(false);
          }}
          onYesClick={dialogData.action}
        />
      )}
    </StyledContainer>
  );
};

export default RNPActions;
